import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ContentService from '../ContentCreater/ContentService';
import '../ContentDisplay/ContentDisplay.css';

const ContentDisplay = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState(null);

  // 🔐 Check role from localStorage
  const userRole = localStorage.getItem('role');
  const isAdmin = userRole === 'ADMIN';

  useEffect(() => {
    if (id) {
      ContentService.getContent(id)
        .then(setContent)
        .catch((err) => console.error('Failed to load content', err));
    }
  }, [id]);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  // 📝 When admin clicks Edit, go to edit route
  const handleEdit = () => {
    navigate(`/content/edit/${id}`);
  };

  if (!content) {
    return (
      <div className="contentPage">
        <main className="contentMain loadingState">
          <p>Loading content...</p>
        </main>
      </div>
    );
  }

  const imageUrls = content.images
    ? content.images
        .split(',')
        .map((u) => u.trim())
        .filter(Boolean)
    : [];

  return (
    <div className="contentPage">
      {/* Hero / header area */}
      <header className="contentHeader">
        <div className="headerInner">
          <div className="headerTopRow">
            <button
              className="backButton"
              onClick={handleBack}
              aria-label="Go back"
            >
              <span className="backArrow">←</span>
              <span className="backText">Back</span>
            </button>

            {/* 🔐 Edit button only for ADMIN */}
            {isAdmin && (
              <button
                className="editButton"
                onClick={handleEdit}
                aria-label="Edit this content"
              >
                Edit
              </button>
            )}
          </div>

          {content.extraData && (
            <p className="contentTypePill">
              {content.extraData}
            </p>
          )}

          <h1 className="contentTitle">{content.title}</h1>

          <p className="contentMeta">
            <span className="metaLabel">Category</span>
            <span className="metaValue">{content.category}</span>
          </p>
        </div>
      </header>

      {/* Main article body */}
      <main className="contentMain">
        <article className="contentBody">
          <div
            className="content-html"
            style={{
              fontSize: `${content.font_size || content.fontSize || 16}px`,
            }}
            dangerouslySetInnerHTML={{ __html: content.content }}
          />

          {imageUrls.length > 0 && (
            <section className="image-gallery">
              {imageUrls.map((url, index) => (
                <figure key={index} className="image-item">
                  <img src={url} alt={`content-${index}`} />
                </figure>
              ))}
            </section>
          )}
        </article>
      </main>
    </div>
  );
};

export default ContentDisplay;
